import type { RawCommands } from '@tiptap/core';
import { findParentNodeClosestToPos } from '@tiptap/core';

import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    toggleNodeTextWrap: {
      /**
       * Toggle node text wrapping.
       */
      toggleNodeTextWrap: () => ReturnType;
    };
  }
}

export const toggleNodeTextWrap: RawCommands['toggleNodeTextWrap'] =
  () =>
  ({ commands, tr, dispatch }) => {
    if (!dispatch) {
      // toggling should be disabled in list items and layout cells
      return !findParentNodeClosestToPos(
        tr.selection.$from,
        node =>
          node?.type?.name === Node_Type.LAYOUT_CELL || node?.type?.name === Node_Type.LIST_ITEM
      );
    }

    const $from = tr.selection.$from;
    const selectedNode = $from.nodeAfter;
    const nodeType = selectedNode?.type.name || '';
    const nodeContainerData = selectedNode?.attrs.containerData;
    const currentTextWrap = nodeContainerData?.textWrap ?? true;
    return commands.updateAttributes(nodeType, {
      containerData: { ...nodeContainerData, textWrap: !currentTextWrap },
    });
  };
